<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">

          <p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px rgb(12, 92, 200);">{{name}}</span></p>
          <p style="text-align: left; margin-bottom : 20px; margin-top: 30px; line-height: 32px;"><span style="margin-left: 36px; font-size: 16px;">{{desc}}</span></p>
          <div id="Layer1">
            <img src="../../assets/img/pts.png" width="506" height="311" border="0" usemap="#Map">
            <map name="Map">

              <area v-for="item in kyuserList"
                  :key="item"
                    shape="rect" :coords="item.coords" :href="item.linkUrl">
            </map>
          </div>
          <div style="height: 50px;">

          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      kyuserList: [],
      id: "",
      name: "",
      desc: "",
    };
  },
  mounted () {
    // 在站科研用户
    this.id = this.$route.query.id;
    this.name = "公共仪器平台";
    this.desc = "作为转化医学研究支撑系统，设施为转化医学研究团队提供生物医药、诊断试剂、医学材料、诊疗装备、医学数据等多领域所需的大型仪器设备共享服务，涵盖电镜-影像，光谱、波谱、质谱，新药研发与工艺安全性评价，诊疗装备开发服务，生物医学数据分析等领域分析检测与制造技术，为用户提供自主操作、送样检测、CMA报告、按图加工等多种类型的仪器共享模式。同时，依托计算平台能力，设施为用户提供云计算高性能计算、AI超算、大数据云存储等数据服务。";
    this.kyuserList = [
      {
        coords: "11,206,110,296",
        linkUrl: '/service8'
      },
      {
        coords: "81,70,171,160",
        linkUrl: '/service6'
      },
      {
        coords: "211,5,311,105",
        linkUrl: '/service7'
      },
      {
        coords: "345,70,446,160",
        linkUrl: '/service10'
      },
      {
        coords: "395,206,495,296",
        linkUrl: '/service9'
      }
    ];

  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
/* 在站科研用户 */
.b-kyuserList ul {
  margin: 0 30px;
  height: -webkit-fill-available;
  li {
    width: 230px;
    float: left;
    margin-left: 50px;
    margin-right: 40px;
    margin-top: 30px;
    margin-bottom: 20px;
    .b-item-link {
      margin: 0 8px;
      border: 1px solid gray;
      border-radius: 20px;
      display: block;
      padding: 20px 10px;
      height: 180px;
      overflow: hidden;
    }
    .b-item-name {
      text-align: center;
      color: #fff;
      font-size: 18px;
      /* font-weight: bold; */
      height: 25px;
      line-height: 25px;
      word-wrap: break-word;
      word-break: normal;
      margin-top: 60px;
      &:hover {
        color: #fff;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pts/index.vue